import { Route } from 'vue-router'
import { useAuthStore } from '@/stores/auth/useAuthStore'
import { pinia } from '@/main'
import { userTypes } from '@/stores/auth/authTypes'
import { URLS } from '../routes/urlRoutes'
import { checkNoRequiresAuthURL } from '../helpers/routes'
import { MOBILE_URLS } from '@/router/routes/urlMobileRoutes'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import store from '@/store/store'
import { i18n } from '@/plugins/vue-i18n'

export const userTypeGuard = (to: Route, _from: Route, next: any): void => {
  const { userType: routeUserTypes = [] } = to.meta
  const authStore = useAuthStore(pinia)
  const noRequiresAuthURL = !checkNoRequiresAuthURL(to.name ?? '')

  if (
    !routeUserTypes?.includes(userTypes.MOBILE) &&
    authStore.isMobileUser &&
    noRequiresAuthURL &&
    checkPermissions(to)
  ) {
    return next(`/${MOBILE_URLS.EXPEDIENTS}`)
  }

  if (!routeUserTypes?.includes(userTypes.DMS) && authStore.isDMSUser && noRequiresAuthURL && checkPermissions(to)) {
    return next(`/${URLS.REPOSITORY}`)
  }

  if (
    !routeUserTypes?.includes(userTypes.CUSTOMER_PORTAL) &&
    authStore.isCustomerPortal &&
    noRequiresAuthURL &&
    checkPermissions(to)
  ) {
    return next(`/${URLS.EXPEDIENTS}`)
  }

  if (
    !routeUserTypes?.includes(userTypes.FACTURE) &&
    authStore.isFactureUser &&
    noRequiresAuthURL &&
    checkPermissions(to)
  ) {
    return next(`/${URLS.BILLING}/${URLS.CUSTOMER_INVOICES}`)
  }

  next()
}

const checkPermissions = (to: Route): boolean => {
  const { entityType } = to.meta
  const { canView, canSave } = store.getters[`${ModuleNamespaces.AUTH}/getPermission`](entityType)
  const isNewRegisterView = to.path.includes(i18n.t('routes.new') as string)

  return !canView || (!canSave && isNewRegisterView)
}
